// Update your src/components/Auth/Login.js file
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Button, Card, Alert } from 'react-bootstrap';
import GoogleButton from 'react-google-button';
import { useUserAuth } from '../../context/UserAuthContext';
import { FaInfoCircle } from 'react-icons/fa';
import './Auth.css';

const Login = () => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { signInWithGoogle } = useUserAuth(); // Use the context function

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);

    try {
      // Use the signInWithGoogle function from context
      await signInWithGoogle();
      
      // Check if there's a return URL in sessionStorage
      const returnUrl = sessionStorage.getItem('returnUrl');
      if (returnUrl) {
        // Clear the return URL from session storage
        sessionStorage.removeItem('returnUrl');
        // Navigate to the return URL
        navigate(returnUrl);
      } else {
        // Default navigation to home
        navigate('/');
      }
    } catch (err) {
      setError(err.message);
      console.error('Google login error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneLogin = () => {
    navigate('/phone-login');
  };

  return (
      <div className="auth-container">
        <Card className="auth-card">
          <Card.Body>
            <div className="auth-header">
              <h1 className="auth-title">{t('phoneSignUp.title')}</h1>
              <p className="auth-subtitle">{t('phoneSignUp.chooseMethodLabel')}</p>
            </div>

            {error && <Alert variant="danger" className="auth-error">{error}</Alert>}

            <div className="auth-methods">
              <GoogleButton
                  className="google-btn"
                  onClick={handleGoogleLogin}
                  disabled={loading}
                  label={t('phoneSignUp.signInWithGoogle')}
              />

              <div className="auth-divider">
                <span>{t('phoneSignUp.or')}</span>
              </div>

              <Button
                  variant="primary"
                  className="phone-btn"
                  onClick={handlePhoneLogin}
                  disabled={loading}
              >
                {t('phoneSignUp.signInWithPhone')}
              </Button>
            </div>
            
            <div className="auth-footer">
              <Button
                  variant="outline-secondary"
                  className="cancel-btn"
                  onClick={() => navigate('/')}
                  disabled={loading}
              >
                {t('phoneSignUp.buttonCancel')}
              </Button>
              
              <div className="terms-policy-notice">
                <p className="terms-text">
                  <FaInfoCircle className="terms-icon" />
                  {t('loginTermsNotice')}
                  <Link 
                    to="/terms-policy" 
                    className="terms-link"
                    onClick={() => sessionStorage.setItem('returnToAfterTerms', '/login')}
                  >
                    {t('termsAndPolicy')}
                  </Link>
                </p>
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
  );
};

export default Login;